// extracted by mini-css-extract-plugin
export default {"colSmOffset0":"Col-module--colSmOffset0--23fb8","colMdOffset0":"Col-module--colMdOffset0--5b966"};